var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"relative"},[_c('span',{staticClass:"cursor-pointer",on:{"mouseenter":_vm.show,"mouseleave":_vm.hide,"click":_vm.toggleVisible}},[_vm._t("trigger")],2),_c('transition',{attrs:{"name":"fade"}},[_c('div',{class:{
        'modal w-half max-w-xs bg-dark bg-opacity-75 text-white p-5 rounded-lg absolute': true,
        'tooltip-top': _vm.top,
        hidden: !_vm.visible
      },on:{"click":_vm.toggleVisible}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }